import { maxBy, findIndex, get } from 'lodash'
import moment from 'moment'

export default function(awards) {
  if (!awards) {
    return 0
  }
  const activeAward = maxBy(awards, award => moment(award.registrationDate))

  return findIndex(awards, award => award.id === activeAward.id)
}

export const getActiveAwardId = awards => {
  if (!awards) {
    return 0
  }
  const activeAward = maxBy(awards, award => moment(award.registrationDate))

  return get(activeAward, 'id')
}
